export class GenderReferenceModel {
    public genderCode: string;
    public genderName: string;
    public sortSequence: number;
}